import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSDMESubmittal, updateSDMEQuotation } from 'src/_helpers/api';

const name = 'sdmeSubmittals';

const initialState = {
  sdmeSubmittals: [],
  error: null,
};

const addSDMESubmittalAsync = createAsyncThunk(`${name}/add-sdme-submittal`, async (submittalData, { rejectWithValue }) => {
  try {
    const response = await createSDMESubmittal(submittalData);
    //console.log('🚀 ~ API response received:', response);
    return response;
  } catch (error) {
    //console.error('🚀 ~ Error occurred in addSubmittalAsync:', error);
    return rejectWithValue(error.response ? error.response.data : 'Unknown error');
  }
});

const updateSDMESubmittalAsync = createAsyncThunk(`${name}/update-sdme-submittal`, async (submittalData) => {
  console.log('🚀 ~ submittalData:', submittalData)
  return await updateSDMEQuotation(submittalData)
})

const sdmeSubmittalSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.sdmeSubmittals = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addSDMESubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addSDMESubmittalAsync.fulfilled, (state, action) => {
        state.sdmeSubmittals.push(action.payload);
      })
      .addCase(addSDMESubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(updateSDMESubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(updateSDMESubmittalAsync.fulfilled, (state, action) => {
        const index = state.sdmeSubmittals.findIndex(s => s.id === action.payload.id);
        if (index !== -1) state.sdmeSubmittals[index] = action.payload;
      })
      .addCase(updateSDMESubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const sdmeSubmittalActions = {
  ...sdmeSubmittalSlice.actions,
  addSDMESubmittalAsync,
  updateSDMESubmittalAsync,
};

export const sdmeSubmittalsReducer = sdmeSubmittalSlice.reducer;
